import {
    setESPEquipmentForSensor,
    setESPEquipmentsForMotor,
    setMotorInputHP,
    setMotorInputHP60,
    setMotorLoadInput,
    setSelectedMotor
} from "../../../../src/store/calculation/calculation-output/motorSlice";
import { useAppDispatch } from "../../../store/hooks/StoreHooks";
import { MotorDto } from "../../../store/model/calculations/motor";

const useMotorFacade = () => {
    const dispatch = useAppDispatch();

    const updateMotorHP_60 = async (payload: any) => {
        return await dispatch(setMotorInputHP60(payload));
    };

    const updateMotorHP = async (payload: any) => {
        return await dispatch(setMotorInputHP(payload));
    };

    const updateSelectedMotor = async (payload: MotorDto) => {
        return await dispatch(setSelectedMotor(payload));
    };

    const updateMotorRating = async (payload: any) => {
        return await dispatch(setMotorLoadInput(payload));
    };

    const updateESPEquipmentsForMotor = (payload: any) => {
        return dispatch(setESPEquipmentsForMotor(payload));
    };

    const updateESPEquipmentsForMotorSensor = (payload: any) => {
        return dispatch(setESPEquipmentForSensor(payload));
    };


    return {
        // loadMotorData,
        updateMotorHP_60,
        updateMotorHP,
        updateSelectedMotor,
        updateMotorRating,
        updateESPEquipmentsForMotor,
        updateESPEquipmentsForMotorSensor
    };
};

export default useMotorFacade;
